var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("SeaExport.CabinCopy"),
        width: "400px",
        "custom-class": "cabin-duplicate-dialog",
        top: "5vh",
        "close-on-click-modal": false
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.cabinForm,
            "label-position": "left",
            "label-width": "80px"
          }
        },
        _vm._l(5, function(i) {
          return _c(
            "fieldset",
            { key: i },
            [
              _c("legend", [
                _vm._v(_vm._s(_vm.$t("SeaExport.ShippingSpace") + i))
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.ShippingCompany"),
                    prop: "carrierId" + i
                  }
                },
                [
                  _c("cargo-company-select", {
                    attrs: {
                      no: "1",
                      "method-params": {
                        companyLob: "seaExport",
                        seaCmp: true,
                        active: true
                      },
                      "default-value": _vm.cabinForm["carrierId" + i]
                    },
                    on: {
                      change: function(p) {
                        _vm.cabinForm["carrierId" + i] = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.BookingAgent"),
                    prop: "bookingAgent" + i
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "2",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      filterable: "",
                      "method-params": {
                        bookingAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.cabinForm["bookingAgent" + i]
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.cabinForm["bookingAgent" + i] = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.DateOfDeparture"),
                    prop: "etd" + i
                  }
                },
                [
                  _c("cargo-date-time-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { no: "3", "value-format": "yyyy-MM-dd" },
                    model: {
                      value: _vm.cabinForm["etd" + i],
                      callback: function($$v) {
                        _vm.$set(_vm.cabinForm, "etd" + i, $$v)
                      },
                      expression: "cabinForm[`etd${i}`]"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "4", type: "primary" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "5" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }